import React from 'react';
import AsyncModule from '../../utils/asyncModule';
import extract from '../../utils/extractUrlParams';

const loader = async () => {
    return await import(/* webpackChunkName: "NotFound" */ './views/main.c');
};

export default class extends React.Component {
    static displayName = 'NotFound';

    render() {
        return (
            <AsyncModule
                {...this.props}
                params={extract(
                    this.props.match && this.props.match.params && this.props.match.params.json,
                )}
                loader={loader}
            />
        );
    }
}
